import { ProfileConfig, Profile } from '@foxcorp/foxkit-profile-js';
import Cookies from 'universal-cookie';
import { getDefaultConfig } from './Store';
import { getAccessToken } from './UserCookie';

//Helpers related to ProfileSDK

const cookies = new Cookies();

let profile = {};

export const profileSDK = () => profile;

export const createProfile = () => {
  const { lastKnownProfileIdCookieName, appVersion, appEnv, accountApiKey, foxApi } = getDefaultConfig();

  const config = {
    apiKey: accountApiKey, // your api key
    baseUrl: foxApi,
    environment: appEnv, // dev, qa, staging, prod (defaults to prod)
    accessToken: getAccessToken(), // optional user accessToken, otherwise undefined
    profileId: cookies.get(lastKnownProfileIdCookieName), // optional user profileId, otherwise undefined
    appName: 'fox-nation-commerce', // required - your app name, e.g. 'Fox Now',
    appVersion, // required - your app version
    httpClientTimeout: 10000, // the number of milliseconds before an http request times out
  };

  const profileConfig = new ProfileConfig(config);
  profile = new Profile(profileConfig);
};
